<template>
  <WsMain
    v-if="modelData"
    :style="[{'padding-bottom':'220px'}]"
  >
    <!-- <WsBackLabel
      @click="$router.go(-1)"
      :label="_backRouteText"
    /> -->
    <WsBreadCrumbs :items="_breadcrumbsItems"></WsBreadCrumbs>
    <WsTitle>{{_title}} <span v-if="_isPostVersion">{{"(尚未發布的新版本)"}}</span></WsTitle>
    <!-- custom should not change default -->
    <div class="ws-button-group">
      <WsBtn
        color="textSecondary"
        outlined
        @click="$_onAvatarOpen()"
      >
        <v-icon left>mdi-account-circle</v-icon> 更換頭像
      </WsBtn>
      <WsBtn
        color="textSecondary"
        outlined
        @click="$_onAccountOpen()"
      >
        <v-icon left>mdi-pencil</v-icon> 編輯帳號設定
      </WsBtn>
      <WsBtn
        color="textSecondary"
        outlined
        @click="$_onPasswordOpen()"
      >
        <v-icon left>mdi-lock</v-icon> 修改密碼
      </WsBtn>
      <span
        v-for="(item,index) in customBtns"
        :key="index"
        class="mx-2"
      >
        <WsBtn
          v-show="$_checkDisplayOnModelData(item.checkDisplayOnModelData)"
          :color="item.color"
          item.type
          :outlined="item.outlined"
          :to="item.to"
          @click="$_onCustom(item)"
        >
          <v-icon left>{{item.icon}}</v-icon> {{item.title}}
        </WsBtn>
      </span>
    </div>
    <div class="ws-content-section">
      <div class="ws-content-section__primary">
        <WsReadContentBlock
          v-for="(item,itemKey) in primary"
          :key="itemKey"
          :type="item.type"
          :label="item.label"
          :title="item.title"
          :remark="item.remark"
          :floors="item.floors"
          :modedFields="fields"
          :fields="item.fields"
          :activeText="item.activeText"
          :inactiveText="item.inactiveText"
          :field="item.field"
          :locale="_selectingLocale"
          :modelName="item.modelName"
          :modelVersionName="item.modelVersionName"
          :searchMode="item.searchMode"
          :batchMode="item.batchMode"
          :modeVersions="item.modeVersions"
          :modeParent="item.modeParent"
          :customButtons="item.modeVersionscustomButtons"
          :modelData="modelData"
          :modelId="id"
          :titleKey="item.titleKey"
          :fieldsRead="item.fieldsRead"
          :subVersionFields="item.subVersionFields"
          :subVersionFieldsReads="item.subVersionFieldsReads"
          :rootModelName="modelName"
          :orderBy="item.orderBy"
          :orderWay="item.orderWay"
          :parentModelName="$_getParentModelName(item)"
          :parentState="$_getParentState(item)"
          :hideOnNull="item.hideOnNull"
          :filterSelects="filterSelects"
          :showExpand="showExpand"
          :showFields="showFields"
          :tabSetting="tabSetting"
          :createVersion="createVersion"
          :itemVersionCreatable="_itemVersionCreatable"
          :itemVersionLinkCreatable="_itemVersionLinkCreatable"
          :itemVersionReadable="_itemVersionReadable"
          :itemDeletable="_itemDeletable"
          :itemEditable="_itemEditable"
          :itemLinkCheckable="_itemLinkCheckable"
          :sequenceFields="_sequenceFields"
          :params="$_getParams(item)"
          :postData="$_getPostData(item)"
          :isGetAll="item.isGetAll"
          :hasSequence="hasSequence"
          :hasChapters="hasChapters"
          :hasCatchVersion="hasCatchVersion"
          :customParentData="item.customParentData"
          :expandDisable="item.expandDisable"
          @created="$_onCreated($event)"
          @deleted="$_onDeleted($event)"
        ></WsReadContentBlock>
      </div>
      <div
        class="ws-content-section__secondary"
        v-if="secondary.length"
      >
        <WsReadContentBlock
          v-for="(item,itemKey) in secondary"
          :key="itemKey"
          :type="item.type"
          :label="item.label"
          :title="item.title"
          :remark="item.remark"
          :floors="item.floors"
          :modedFields="fields"
          :fields="item.fields"
          :activeText="item.activeText"
          :inactiveText="item.inactiveText"
          :field="item.field"
          :locale="_selectingLocale"
          :modelName="item.modelName"
          :modelVersionName="item.modelVersionName"
          :searchMode="item.searchMode"
          :batchMode="item.batchMode"
          :modeVersions="item.modeVersions"
          :modeParent="item.modeParent"
          :customButtons="item.customButtons"
          :modelData="modelData"
          :modelId="id"
          :titleKey="item.titleKey"
          :fieldsRead="item.fieldsRead"
          :orderBy="item.orderBy"
          :orderWay="item.orderWay"
          :parentModelName="$_getParentModelName(item)"
          :parentState="$_getParentState(item)"
          :hideOnNull="item.hideOnNull"
          :filterSelects="filterSelects"
          :showExpand="showExpand"
          :showFields="showFields"
          :tabSetting="tabSetting"
          :createVersion="createVersion"
          :itemVersionCreatable="_itemVersionCreatable"
          :itemVersionLinkCreatable="_itemVersionLinkCreatable"
          :itemVersionReadable="_itemVersionReadable"
          :itemDeletable="_itemDeletable"
          :itemEditable="_itemEditable"
          :itemLinkCheckable="_itemLinkCheckable"
          :sequenceFields="_sequenceFields"
          :params="$_getParams(item)"
          :isGetAll="item.isGetAll"
          :hasSequence="hasSequence"
          :hasChapters="hasChapters"
          :hasCatchVersion="hasCatchVersion"
          :customParentData="item.customParentData"
          :expandDisable="item.expandDisable"
          @created="$_onCreated($event)"
          @deleted="$_onDeleted($event)"
        ></WsReadContentBlock>
      </div>
    </div>
    <!-- Delete Dialog -->
    <WsAlertDialog
      ref="deleteDialog"
      title="確定要刪除嗎？"
      description="刪除後資料將無法回覆"
      @submit="$_onDeleteSubmit($event)"
    />
    <WsAlertDialog
      ref="createVersionDialog"
      :title="alertTitle"
      :description="alertDescription"
      :btnText="btnText"
      @submit="$_onDeleteSubmit($event)"
    />
    <WsUpdateDialog
      ref="avatarDialog"
      customTitle
      label="更換頭像"
      :fields="_avatarFields"
      :modelName="modelName"
      :errorMessages="updateErrorMessages"
      @update-submit="$_onAvatarSubmit($event)"
    />
    <WsUpdateDialog
      ref="accountDialog"
      :label="label"
      :fields="_accountFields"
      :modelName="modelName"
      :errorMessages="updateErrorMessages"
      @update-submit="$_onAccountSubmit($event)"
    />
    <WsUpdateDialog
      ref="passwordDialog"
      customTitle
      label="修改密碼"
      :fields="_passwordFields"
      :modelName="modelName"
      :errorMessages="updateErrorMessages"
      @update-submit="$_onPasswordSubmit($event)"
    />
    <!-- Read Dialog -->
    <!-- <WsReadDialog
      ref="readDialog"
      :fields="_displayFields"
      :titleKey="titleKey"
      @delete-submit="$_onReadDialogDeleteSubmit($event)"
      @update="$_onReadDialogUpdate($event)"
    /> -->
    <slot></slot>
  </WsMain>
</template>

<script>
export default {
  data: () => ({
    modelData: null,
    createErrorMessages: null,
    updateErrorMessages: {},
    updateTitle: "",
    updateFields: null,
    alertTitle: "",
    alertDescription: "",
    btnText: "",
  }),
  props: {
    titleKey: {
      type: String,
      default: "text",
    },
    modeVersions: {
      type: Boolean,
      default: false,
    },
    versionModelName: {
      type: String,
      default: "",
    },
    backRouteText: {
      type: String,
      default: "返回",
    },
    backRoute: {
      type: String,
      default: null,
    },
    primary: {
      type: Array,
      default() {
        return [];
      },
    },
    secondary: {
      type: Array,
      default() {
        return [];
      },
    },
    id: {
      type: [String, Number],
      default: null,
    },
    localeMode: {
      type: Boolean,
      default: false,
    },
    customBtns: {
      type: Array,
      default() {
        return [];
      },
    },
    modelVersionName: {
      type: String,
      default: "",
    },
    isMultiSelect: {
      type: Boolean,
      default: false,
    },
    filterSelects: {
      type: Array,
      default: null,
    },
    showExpand: {
      type: Boolean,
      default: true,
    },
    showFields: {
      type: Array,
    },
    tabSetting: {
      type: Array,
    },
    submodelVerisonName: {
      type: String,
      default: "",
    },
    submodelVerisonFullName: {
      type: String,
    },
    createVersion: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    sortable: {
      type: Boolean,
      default: false,
    },
    versionCreatable: {
      type: Boolean,
      defualt: false,
    },
    hasSequence: {
      type: Boolean,
      default: false,
    },
    hasChapters: {
      type: Boolean,
      default: false,
    },
    isGetAll: {
      type: Boolean,
      default: false,
    },
    backLabel: String,
    modelName: String,
    submodelName: String,
    label: String,
    fields: Object,
    hasCatchVersion: {
      type: Boolean,
      default: false,
    },
    avatarHideFields: {
      type: Array,
    },
    accountHideFields: {
      type: Array,
    },
    passwordHideFields: {
      type: Array,
    },
    getDefaultImg: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _avatarFields() {
      return this.$_CMS_geUpdateFields(this.fields, this.avatarHideFields);
    },
    _accountFields() {
      return this.$_CMS_geUpdateFields(this.fields, this.accountHideFields);
    },
    _passwordFields() {
      return this.$_CMS_geUpdateFields(this.fields, this.passwordHideFields);
    },
    _updateFields() {
      return this.$_CMS_geUpdateFields(this.fields, this.updateHideFields);
    },
    _createFields() {
      return this.$_CMS_geUpdateFields(this.fields, this.createHideFields);
    },
    _sequenceFields() {
      if (this.hasSequence) {
        return this.modelData.last_version.questions;
      } else if (this.hasChapters) {
        return this.modelData.last_version.chapters;
      } else if (this.hasCatchVersion) {
        return this.modelData.last_version[`${this.submodelName}s`];
      } else {
        return null;
      }
    },
    _itemVersionLinkCreatable() {
      if (this.hasChapters || this.hasCatchVersion) {
        return false;
      } else if (this.modeVersions && !this.hasSequence) {
        return true;
      } else {
        return false;
      }
    },
    _itemVersionCreatable() {
      if (!this.hasSequence || this.hasCatchVersion) {
        return false;
      } else if (!this.modeVersions) {
        return false;
      } else if (this.hasSequence) {
        if (!this.modelData.last_version.status) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    _itemVersionReadable() {
      if (this.hasChapters || this.hasCatchVersion) {
        return false;
      } else if (this.modeVersions && !this.hasSequence) {
        return true;
      } else if (!this.modeVersions) {
        return true;
      } else if (this.hasSequence) {
        if (!this.modelData.last_version.status) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    _itemEditable() {
      if (this.hasChapters || this.hasCatchVersion) {
        return false;
      } else if (this.modeVersions && !this.hasSequence) {
        return true;
      } else if (!this.modeVersions) {
        return true;
      } else if (this.hasSequence) {
        if (!this.modelData.last_version.status) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    _itemDeletable() {
      if (this.hasChapters || this.hasCatchVersion) {
        return false;
      } else {
        return true;
      }
    },
    _itemLinkCheckable() {
      if (this.hasCatchVersion) {
        return true;
      } else {
        return false;
      }
    },
    _isPostVersion() {
      if (this.hasSequence || this.hasChapters) {
        if (!this.modelData.last_version.status) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
    _title() {
      if (!this.modelData) {
        return this.label;
      } else if (this.modelData.name) {
        return this.modelData.name;
      } else if (!this.modelData.last_version) {
        return "";
      } else {
        return this.$_CMS_getValueByFieldKey(this.titleKey, this.modelData);
      }
    },
    _breadcrumbsItems() {
      const _breadcrumbsItems = [];
      _breadcrumbsItems.push({
        text: this.label,
        to: `/${this.modelName}`,
        disabled: false,
      });
      _breadcrumbsItems.push({
        text: this._title,
        disabled: true,
      });
      return _breadcrumbsItems;
    },
    _backRouteText() {
      if (this.backRouteText) {
        return "返回";
      } else {
        return `${this.label}列表`;
      }
    },
    _backRoute() {
      if (this.backRoute) {
        return this.backRoute;
      } else {
        return `/${this.modelName}`;
      }
    },
  },
  methods: {
    $_onCreateOpen() {
      this.createErrorMessages = null;
      this.$refs.createDialog.open();
    },
    $_onAvatarOpen() {
      this.$refs.avatarDialog.open(this.modelData);
    },
    $_onAccountOpen() {
      this.$refs.accountDialog.open(this.modelData);
    },
    $_onPasswordOpen() {
      this.$refs.passwordDialog.open(this.modelData);
    },
    $_getParams(item) {
      let _params = {};
      if (item.modeParent) {
        if (this.hasSequence || this.hasChapters || this.hasCatchVersion) {
          _params[`${this.modelName}s`] = this.modelData.id;
        }
      }
      if (item.modeParentVersions) {
        if (this.hasSequence || this.hasChapters || this.hasCatchVersion) {
          _params[`${this.modelVersionName}s`] = this.modelData.last_version.id;
        } else {
          _params[`${this.modelName}_version`] = this.$_getParentState(item);
        }
      }
      return _params;
    },
    $_getPostData(item) {
      let _params = {};
      if (item.modeParent) {
        if (this.hasSequence || this.hasChapters) {
          _params[`${this.modelName}s`] = this.modelData.id;
        } else {
          _params[`${this.modelName}`] = this.$_getParentState(item);
        }
      }
      if (item.modeParentVersions) {
        if (this.hasSequence || this.hasChapters) {
          _params[`${this.modelVersionName}s`] = this.modelData.last_version.id;
        } else {
          _params[`${this.modelName}_version`] = this.$_getParentState(item);
        }
      }
      return _params;
    },
    async $_onCreated($event) {
      if (this.hasSequence) {
        // has version or has no version
        try {
          let newArr = [];
          if (this.modelData.last_version.questions) {
            newArr = JSON.parse(
              JSON.stringify(this.modelData.last_version.questions)
            );
          }
          newArr.push({ id: $event.id });
          await this.$axios.patch(
            `/${this.modelVersionName}/${this.modelData.last_version.id}`,
            { questions: newArr }
          );
          if (!this.modelData.last_version.questions) {
            this.modelData.last_version.questions = [];
          }
          this.modelData.last_version.questions.push({ id: $event.id });
        } catch (error) {
          alert(error);
        }
      }
    },
    async $_onDeleted($event) {
      if (this.hasSequence) {
        const tarIndex = this.modelData.last_version.questions.findIndex(
          (e) => {
            return e.id == $event;
          }
        );
        // this.modelData.last_version.questions.splice(tarIndex, 1);
        let newObj = {};
        newObj.questions = JSON.parse(
          JSON.stringify(this.modelData.last_version.questions)
        );
        newObj.questions.splice(tarIndex, 1);
        if (newObj.questions) {
          newObj[`${this.submodelName}s`] =
            this.modelData.last_version.questions.map((item) => {
              return item.id;
            });
        }
        await this.$axios.patch(
          `/${this.modelVersionName}/${this.modelData.last_version.id}`,
          newObj
        );
        this.modelData.last_version.questions.splice(tarIndex, 1);
      }
    },
    $_onDelete($event) {
      this.$refs.deleteDialog.open($event);
    },
    async $_onSortOpen() {
      this.createErrorMessages = ["尚未填寫章", "尚未填寫節"];
      this.$refs.sortDialog.open();
    },
    async $_onSortSubmit(val) {
      //update api
      try {
        let newObject = {};
        if (this.hasChapters) {
          newObject.chapters = JSON.parse(JSON.stringify(val));
          newObject.chapters.forEach((chapterItem) => {
            chapterItem.sections.forEach((sectionItem) => {
              sectionItem.topics.forEach((topicItem) => {
                delete topicItem.topicTitle;
              });
            });
          });
          const getUrl = `/${this.modelVersionName}/${this.modelData.last_version.id}`;
          const res = await this.$axios.patch(getUrl, newObject);
          this.modelData.last_version.chapters = res.data.data.chapters;
        } else {
          newObject.questions = JSON.parse(JSON.stringify(val));
          newObject.questions.forEach((questionItem) => {
            delete questionItem.title;
          });
          const getUrl = `/${this.modelVersionName}/${this.modelData.last_version.id}`;
          const res = await this.$axios.patch(getUrl, newObject);
          this.modelData.last_version.questions = res.data.data.questions;
        }
        await this.$_fetchData();
      } catch (error) {
        alert(error);
      }
    },
    async $_onAvatarSubmit($event) {
      try {
        await this.$axios.patch(`/${this.modelName}/user`, $event);
        this.modelData = {
          ...this.modelData,
          ...$event,
        };
        this.$refs.avatarDialog.close();
      } catch (error) {
        alert(error);
      }
    },
    async $_onAccountSubmit($event) {
      try {
        const res = await this.$axios.patch(`/${this.modelName}/user`, $event);
        this.modelData = res.data.data;
        this.$refs.accountDialog.close();
      } catch (error) {
        alert(error);
      }
    },
    async $_onPasswordSubmit($event) {
      try {
        await this.$axios.patch(`/${this.modelName}/user/password`, $event);
        this.$refs.passwordDialog.close();
      } catch (err) {
        if (err.response.data.message == "password not correct.") {
          this.$set(this.updateErrorMessages, "password", "密碼輸入錯誤");
        } else {
          this.$set(this.updateErrorMessages, "new_password", "新密碼驗證錯誤");
        }
      }
    },
    async $_onCustom(item) {
      if (item.emit) {
        this.$emit(item.emit, { modelData: this.modelData });
      }
    },
    $_getParentState(primaryItem) {
      if (primaryItem.modeParentVersions && this.modelData.last_version) {
        return this.modelData.last_version.id;
      } else {
        return this.modelData.id;
      }
    },
    $_getParentModelName(primaryItem) {
      if (primaryItem.modeParentVersions) {
        return `${this.modelName}_version`;
      } else {
        return this.modelName;
      }
    },
    async $_fetchData() {
      this.$store.dispatch("app/startPageLoading");
      this.$store.dispatch("locale/changeLanguageAble");
      let getUrl = `/${this.modelName}/user`;
      if (this.localeMode) {
        getUrl += `?locale=${this._selectingLocale}`;
      }
      try {
        const res = await this.$axios.get(getUrl);
        this.modelData = res.data.user;
        this.modelData.fake_password = "•••••••••••••";
        if (this.getDefaultImg && !this.modelData.avatar) {
          this.modelData.avatar = require(`@/__vue2cmsstonevuetify/assets/img/ws_avatar_default.png`);
        }
      } catch (error) {
        alert(error);
      } finally {
        this.$store.dispatch("app/stopPageLoading");
      }
    },
    $_checkDisplayOnModelData(displayModelData) {
      if (!displayModelData) {
        return true;
      } else {
        return displayModelData(this.modelData);
      }
    },
  },
  mounted() {
    this.$_fetchData();
  },
};
</script>